import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import CategoryService from './services/CategoryService'
import DomesticSearchService from './services/DomesticSearchService'

export const postDomesticSearch = createAsyncThunk(
  'domesticSearch/searchList/postDomesticSearch',
  async (data, { rejectWithValue }) => {
    try {
      const response = await DomesticSearchService.postDomesticSearch(data)

      return response.success ? response : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const postDomesticSearchCount = createAsyncThunk(
  'domesticSearch/searchList/postDomesticSearchCount',
  async (data, { rejectWithValue }) => {
    try {
      const response = await DomesticSearchService.postDomesticSearchCount(data)

      return response.success
        ? response.data
        : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getCategoryLegalFormAdjusted = createAsyncThunk(
  'domesticSearch/searchList/getCategoryLegalFormAdjusted',
  async (data, { rejectWithValue }) => {
    try {
      const response = await CategoryService.getCategoryLegalFormAdjusted(data)

      return response.success
        ? response.data
        : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getCompanyStatus = createAsyncThunk(
  'domesticSearch/searchList/getCompanyStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await CategoryService.getCompanyStatus(data)

      return response.success
        ? response.data
        : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
